import {
  Truck, Disc3, ShieldCheck, Sparkles, Tag, Gem, Package, Globe, Star, Heart, Music, Headphones, Award, Zap, Gift, Clock, Warehouse, BadgePercent,
} from "lucide-react";

export const ICONS = {
  truck: Truck, disc: Disc3, shield: ShieldCheck, sparkles: Sparkles, tag: Tag, gem: Gem, package: Package, globe: Globe,
  star: Star, heart: Heart, music: Music, headphones: Headphones, award: Award, zap: Zap, gift: Gift, clock: Clock,
  warehouse: Warehouse, percent: BadgePercent,
};
export const ICON_NAMES = Object.keys(ICONS);

export const DynIcon = ({ name, ...props }) => {
  const C = ICONS[name] || Sparkles;
  return <C {...props} />;
};

export const slugId = (s) => String(s).toLowerCase().replace(/<[^>]+>/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export function renderBody(text = "") {
  const inline = (s, k) =>
    s.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
      part.startsWith("**") && part.endsWith("**") ? <strong key={`${k}-${i}`}>{part.slice(2, -2)}</strong> : part
    );
  return text.split(/\n\s*\n/).filter((b) => b.trim()).map((block, i) => {
    const b = block.trim();
    const img = b.match(/^!\[([^\]]*)\]\((https?:\/\/[^)]+)\)$/);
    if (img) return <img key={i} src={img[2]} alt={img[1]} />;
    if (b.startsWith("### ")) return <h3 key={i} id={slugId(b.slice(4))}>{inline(b.slice(4), i)}</h3>;
    if (b.startsWith("## ")) return <h2 key={i} id={slugId(b.slice(3))}>{inline(b.slice(3), i)}</h2>;
    if (b.split("\n").every((l) => l.trim().startsWith("- ")))
      return <ul key={i}>{b.split("\n").map((l, j) => <li key={j}>{inline(l.trim().slice(2), `${i}-${j}`)}</li>)}</ul>;
    return <p key={i}>{inline(b, i)}</p>;
  });
}
